<template>
  <div class="footer">
    <div class="main">
      <div class="main-top">
        <ul class="clearfix">
          <li>
            <span
              class="iconfont icon-a-ziyuan2"
              style="font-size: 60px;color: #4987F2"
            ></span>
            <!-- <img src="https://g-part.cn/img/partsQuality.4190f860.svg" alt="" /> -->
            <p>
              <span class="main-top-span">质量</span><br />
              <span class="introduce">品质保证、认证商户假一赔三</span>
            </p>
          </li>
          <li>
            <!-- <img src="https://g-part.cn/img/partsFast.67990cdb.svg" alt="" /> -->
            <span
              class="iconfont icon-a-zu182"
              style="font-size: 60px; color: #4987F2"
            ></span>
            <p>
              <span class="main-top-span">品类 </span><br />
              <span class="introduce">品类齐全，一站到齐</span>
            </p>
          </li>
          <li>
            <!-- <img src="https://g-part.cn/img/partsSafe.feccb5c0.svg" alt="" /> -->
            <span
              class="iconfont icon-a-zu183"
              style="font-size: 60px; color: #4987F2"
            ></span>
            <p>
              <span class="main-top-span">库存 </span><br />
              <span class="introduce">即时库存，保证有货</span>
            </p>
          </li>
          <li>
            <!-- <img src="https://g-part.cn/img/partsMoney.225363f3.svg" alt="" /> -->
            <span
              class="iconfont icon-a-zu184"
              style="font-size: 60px; color: #4987F2"
            ></span>
            <p>
              <span class="main-top-span">配送 </span><br />
              <span class="introduce">属地汽配商服务</span>
            </p>
          </li>
        </ul>
      </div>
      <!-- <div class="main-center">
        <ul class="clearfix">
          <li>
            <a href="/test"><i>关于我们</i></a>
          </li>
          <li>
            <a href="/test"><i>线下门店</i></a>
          </li>
          <li>
            <a href="/test"><i>最新动态</i></a>
          </li>
          <li>
            <a href="/test"><i>联系我们</i></a>
          </li>
        </ul>
      </div>
      <div class="main-bottom">
        <ul class="clearfix">
          <li>
            <span
              class="iconfont icon-a-lujing162"
              style="padding-right: 5px"
            ></span>
            <p>客服热线<br />400-000-000-00</p>
          </li>
          <li>
            <p>
              联系地址：北京市朝阳区城环城汽配城35号楼4层D007<br />Copyright@2021
              机汽人(北京)科技有限公司版权所有<br />泸公网安备 11010502040284号
              京ICP备16054851号-2 京B2-20200811
            </p>
          </li>
          <li style="padding-bottom: 10px">
            <div>
              <img src="https://g-part.cn/img/ewm.7c777fae.jpg" alt="" /><br />
              <span>公众号</span>
            </div>
            <div class="main-bottom-div">
              <img src="https://g-part.cn/img/ewm.7c777fae.jpg" alt="" /><br />
              <span>抖音号</span>
            </div>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.footer {
  width: 1200px;
  margin: 0 auto;
  margin-top: 40px;
  // background-color: rgb(111, 230, 164);
  // height: 308px;
  border-top: 2px solid #4987f2;
  .clearfix {
    overflow: hidden;
    _zoom: 1;
  }
  .main {
    width: 1200px;
    margin: 0 auto;
    .main-top {
      ul {
        display: flex;
        li {
          display: flex;
          border-bottom: 1px solid #e2e2e2;
          width: 25%;
          padding: 41px 0;
          padding-left: 50px;

          // padding-top: 31px;
          // padding-bottom: 29px;

          align-items: center;
          // justify-content: center;
          // img {
          //   // width: 60%;
          //   width: 82px;
          //   height: 82px;
          //   padding-right: 10px;
          // }
          .iconfont {
            padding-right: 22px;
          }
          p {
            // width: 200px;
            // display: inline-block;
            font-size: 12px;
            text-align: left;
            white-space: nowrap;
            .main-top-span {
              // font-weight: bold;
              // font-size: 20px;
              // color: #434343;
              width: 40px;
              height: 20px;
              font-size: 20px;
              font-family: Source Han Sans CN;
              letter-spacing: 2px;
              font-weight: bold;
              line-height: 20px;
              color: #434343;
            }
            .introduce {
              display: inline-block;
              margin-top: 7px;
              width: 162px;
              height: 12px;
              font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #787878;
            }
          }
        }
      }
    }
    .main-center {
      ul {
        display: flex;
        li {
          width: 20%;
          padding: 15px 0 27px;
          padding-left: 200px;
          a > i {
            width: 67px;
            font-size: 14px;
            color: #434343;
            display: inline-block;
          }
          a > i:hover {
            color: #e90d0d;
          }
        }
      }
    }
    .main-bottom {
      ul {
        display: flex;
        li:first-child {
          // float: left;
          padding-right: 43px;
          height: 79px;
          // line-height: 79px;
          border-right: 1px solid #e2e2e2;
          text-align: left;
          p {
            display: flex;
            // justify-content: center; //水平
            align-items: center; //垂直
          }
          .iconfont {
            font-size: 30px;
            color: #b4b4b4;
            line-height: 79px;
          }
          p:hover {
            color: #e90d0d;
            cursor: pointer;
          }
        }
        li:nth-child(2) {
          padding-left: 91px;
          padding-right: 90px;
          padding-bottom: 32px;
          word-spacing: 5px;
          line-height: 30px;
        }
        li:last-child {
          span {
            font-size: 12px;
            color: #787878;
          }
        }
        li {
          display: flex;

          p {
            font-size: 12px;
            color: #787878;
            span {
              font-size: 14px;
            }
          }
          img {
            width: 80px;
            height: 80px;
          }
          .main-bottom-div {
            // display: inline-block;
            padding-left: 20px;
          }
        }
      }
    }
  }
}
</style>
